/**
 * Returns the effective invoice status for display and filtering.
 * Prefers the real-time computed status (status_computed) when available from WQL/Elasticsearch;
 * falls back to the persisted database status for backwards compatibility.
 * Returns 'NONE' when status is absent on details. Only call when you have invoice details; do not pass null or undefined.
 *
 * Use this for: display, filtering, badges, counts.
 * Continue using invoiceDetails.status for: write operations (e.g. setting status to VOID).
 */
export function getInvoiceStatus(invoiceDetails) {
    const status = invoiceDetails.status_computed ?? invoiceDetails.status;
    return status ?? 'NONE';
}
//# sourceMappingURL=get-invoice-status.js.map